import React, { useContext, useState } from 'react'
import MessageContext from 'shared/components/context/message'
import UrlInput from 'shared/components/inputs/url-input'
import styled from 'styled-components'
import { CreationToolsContext } from '../../../manager'
import CreationToolOutputType from '../../../types/output-type'
import { WelcomeBlock } from '../../blocks'
import { Subtitle, Text, TextInput } from '../../typography'
import { GiphyIcon, VimeoIcon, YoutubeIcon } from './icons'

const Description = styled(Text as any)`
    max-width: 100%;
`

const CreationWelcomeUrlInput = () => {
    const [outputType] = useState<CreationToolOutputType>(CreationToolOutputType.Gif)
    const { setFile } = useContext(CreationToolsContext)
    const { sendMessage } = useContext(MessageContext)

    const onError = (_: Event, message: string) => {
        sendMessage(message, 'error')
    }

    const onFileAccepted = async (files: FileList) => {
        if (files && files.length) {
            const { sourceUrl } = (files as any)[0]
            setFile(sourceUrl, outputType)
        }
    }

    return (
        <WelcomeBlock>
            <Subtitle as="h3">Any URL</Subtitle>
            <Description>We support media URLs from GIPHY, YouTube, Vimeo, &amp; many others!</Description>
            <TextInput>
                <UrlInput
                    {...{
                        placeholder: 'Enter any media or GIF URL',
                        fileTypes: ['.mp4', '.png', '.jpeg', '.jpg', '.gif', 'youtube', 'vimeo'],
                        onError,
                        onFileAccepted,
                    }}
                />
                <GiphyIcon />
                <YoutubeIcon />
                <VimeoIcon />
            </TextInput>
        </WelcomeBlock>
    )
}

export default CreationWelcomeUrlInput
